// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"dd42513d","453":"45897372","455":"ec59ad4f","977":"eef9ff22"}[chunkId] + ".chunk.js";
};